import { render } from "./v-table.vue?vue&type=template&id=c78fcca8&scoped=true"
import script from "./v-table.vue?vue&type=script&lang=js"
export * from "./v-table.vue?vue&type=script&lang=js"

import "./v-table.vue?vue&type=style&index=0&id=c78fcca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c78fcca8"]])

export default __exports__